import {getLocalJson} from "./localStorageUtills";

/**
 * Líné načtení číselníků z localStorage -- při hromadných operacích se každý
 * číselník parsuje nejvýše jednou, ne jednou za každý záznam.
 */
function createLookup() {
    const cache = {};

    return (name) => {
        if (!(name in cache)) {
            cache[name] = getLocalJson(name) ?? [];
        }
        return cache[name];
    };
}

/**
 * Naše firma, ke které záznam patří.
 *
 * U nájmů se firma dohledává přes jednotku a budovu -- stejný řetězec jako
 * ve FilterContext a v DocumentController::get_filling_data().
 */
export function resolveCompanyId(model, item, lookup = null) {
    if (!item) return null;

    if (model === 'companies') return item.id ?? null;
    if (item.company_id) return item.company_id;

    const get = lookup ?? createLookup();

    let facilityId = item.facility_id;
    if (!facilityId && item.rent_id) {
        facilityId = get('rents').find(rent => rent.id === item.rent_id)?.facility_id;
    }

    let buildingId = item.building_id;
    if (!buildingId && facilityId) {
        buildingId = get('facilities').find(facility => facility.id === facilityId)?.building_id;
    }

    if (buildingId) {
        return get('buildings').find(building => building.id === buildingId)?.company_id ?? null;
    }

    return null;
}

/** Firmy pro celý výběr najednou, se sdílenou cache číselníků. */
export function resolveCompanyIds(model, items) {
    const lookup = createLookup();

    return (items ?? []).map(item => resolveCompanyId(model, item, lookup));
}

/** Šablóna bez vyplněné firmy je sdílená -- je dostupná všem našim firmám. */
export function isGlobalTemplate(template) {
    return !template?.company_ids;
}

export function belongsToCompany(template, companyId) {
    if (!companyId) return false;

    return String(template?.company_ids ?? '')
        .split('//')
        .filter(id => id !== '')
        .includes(companyId.toString());
}

/**
 * Nabídka pro ruční výběr. Sdílené šablóny zůstávají dostupné vždy -- vypadnou
 * jen šablóny patřící cizí firmě. Šablóna vlastní firmy se nabídne jako první.
 * Když firmu záznamu neznáme, nabídku nijak neomezujeme.
 */
export function filterTemplatesForCompany(templates, companyId) {
    if (!templates) return [];
    if (!companyId) return templates;

    return [
        ...templates.filter(template => belongsToCompany(template, companyId)),
        ...templates.filter(isGlobalTemplate),
    ];
}

/**
 * Varianta pro hromadný tisk, kde jedna šablóna platí pro více záznamů najednou:
 * nabídne sdílené šablóny plus ty, které patří některé z dotčených firem.
 */
export function templatesAvailableFor(templates, companyIds) {
    const ids = (companyIds ?? []).filter(Boolean);

    if (!templates) return [];
    if (!ids.length) return templates;

    return templates.filter(template =>
        isGlobalTemplate(template) || ids.some(id => belongsToCompany(template, id)));
}
